<template>
  <div v-if="type === 'limit'" class="limit">
    <v-overflow-btn
      class="change_page noneDetails"
      :items="dropdownList"
      :item-text="(i) => i.text"
      :item-value="(i) => i.value"
      v-model="limit"
      ref="ovr_btn"
      height="36px"
      @change="pushParams(1)"
    />
    <span class="all_page" v-if="pageData">
      {{ localStorage.translations.pages.common.pagination['iz'] }}
      {{ pageData.amount || pageData.data.length }}</span
    >
  </div>
  <v-pagination
    v-else-if="type === 'page' && pageData.amount"
    v-model="page"
    :length="pageData ? pageData.lastPage : 0"
    :total-visible="7"
    color="#277faf"
  ></v-pagination>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: 'Pagination',
  props: ['pageData', 'type', 'params'],
  data: () => ({
    limit: 10,
    page: 1,
    pushActive: false,
  }),
  computed: {
    pageComputed() {
      return this.params && this.params.page
        ? parseInt(this.$route.query[this.params.page])
        : parseInt(this.$route.query.page)
    },

    limitComputed() {
      return this.params && this.params.limit
        ? parseInt(this.$route.query[this.params.limit])
        : parseInt(this.$route.query.limit)
    },
    dropdownList() {
      return [
        {
          text: this.localStorage.translations.pages.common.pagination['vse'],
          value: 0,
        },
        {
          text:
            this.type === 'limit' && this.params
              ? parseInt(this.$route.query[this.params.limit])
              : parseInt(this.$route.query.limit),
          value:
            this.type === 'limit' && this.params
              ? parseInt(this.$route.query[this.params.limit])
              : parseInt(this.$route.query.limit),
        },
        { text: 10, value: 10 },
        { text: 25, value: 25 },
        { text: 50, value: 50 },
        { text: 100, value: 100 },
      ]
    },
  },

  watch: {
    page() {
      this.pushParams()
    },
    pageComputed() {
      this.page = this.pageComputed
    },
    limitComputed() {
      this.limit = this.limitComputed
    },
  },
  mounted() {
    this.page =
      this.params && this.params.page
        ? parseInt(this.$route.query[this.params.page])
        : parseInt(this.$route.query.page)
    this.limit =
      this.params && this.params.limit
        ? parseInt(this.$route.query[this.params.limit])
        : parseInt(this.$route.query.limit)
  },
  methods: {
    pushParams(page) {
      // console.log('pushParams')
      let query = Object.assign({}, this.$route.query)
      query[this.params ? this.params.page : 'page'] = page ? page : this.page
      query[this.params ? this.params.limit : 'limit'] = this.limit
      let local = localStorage.getItem('queryParams')
      local = local ? JSON.parse(localStorage.getItem('queryParams')) : {}
      if (!!this.$route.params.id) {
        // console.log(this.$route.params.id)
        if (!local[this.$route.name]) local[this.$route.name] = {}
        local[this.$route.name][this.$route.params.id] = query
      } else local[this.$route.name] = query
      localStorage.setItem('queryParams', JSON.stringify(local))
      this.$router.push({ query }).catch(() => {
        this.pushActive = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.limit:deep() {
  display: grid;
  grid-template-columns: 80px auto;
  grid-column-gap: 15px;
  align-items: center;
  align-content: center;
  font-size: 13px;
  .all_page {
    display: block;
    text-transform: lowercase;
    color: #2c2c2c;
  }
  .change_page {
    margin-top: 0;
    padding-top: 0;
    .v-input__control {
      display: grid;
      align-items: center;

      .v-input__slot {
        margin: 0;
        border: none;
        background: #ffffff !important;
        border-radius: 10px;
        cursor: pointer;
        user-select: none;
        margin-bottom: 0 !important;
        min-height: 40px !important;
        box-shadow: none;
        .v-select__slot {
          width: 80px;
          height: 40px;
        }
        .v-input__append-inner {
          margin-top: 0 !important;
        }
        .v-select__selection--comma {
          overflow: visible;
          font-size: 13px;
        }
        .v-icon {
          color: #52525f !important;
        }
        &:hover {
          background: #16558f !important;
          .v-select__selection--comma {
            color: #ffffff !important;
          }
          .v-icon {
            color: #ffffff !important;
          }
        }
      }
    }
    .v-input__append-inner {
      height: 40px !important;
    }
    &.v-select--is-menu-active {
      .v-input__slot {
        background: #16558f !important;
        .v-select__selection--comma {
          color: #ffffff !important;
        }
        .v-icon {
          color: #ffffff !important;
        }
      }
    }
  }
}
:deep().v-pagination {
  .v-pagination__navigation {
    background: transparent !important;
    box-shadow: none;
    .v-icon {
      font-size: 22px;
      color: #2c2c2c !important;
    }
    &--disabled {
      color: #f2f4f6 !important;
      .v-icon {
        color: #52525f !important;
      }
    }
    &:hover {
      .v-icon {
        color: #277faf !important;
      }
    }
  }
  .v-pagination__item {
    font-weight: 500;
    font-size: 14px !important;
    color: #2c2c2c !important;
    background: transparent !important;
    box-shadow: none;
    border-radius: 5px;
    min-width: 30px;
    min-height: 30px;
    height: 30px;
    &--active {
      background-color: #277faf !important;
      border-color: inherit !important;
      color: #ffffff !important;
    }
    &:not(.v-pagination__item--active):hover {
      color: #277faf !important;
    }
  }
}
</style>
